export default (state, action) => {
  return Object.assign({}, state, {
    data: {
      ...state.data,
      wishlistItems: action.payload,
    },

    loading: false,
  });
};
